import React from "react";
import { Flex, FlexProps, Image, Link } from "@chakra-ui/react";
import logo from "assets/logo.png";
import { UserProfile, OfflineMark } from "./components";

interface HeaderProps extends FlexProps {
  navSize: "sm" | "lg";
}

const Header: React.FC<HeaderProps> = ({ navSize, ...rest }) => (
  <Flex
    as="header"
    position="sticky"
    top={0}
    zIndex={5}
    bgColor="gray.50"
    px={{ base: 6, lg: 16 }}
    {...rest}
  >
    <Flex w="full" borderBottom="1px solid" borderColor="gray.200">
      {navSize === "sm" && (
        <Flex align="center">
          <Link href="/">
            <Image src={logo} alt="Logo" w="122px" h="46px" />
          </Link>
        </Flex>
      )}
      <Flex columnGap={14} align="center" justify="end" flex={1}>
        <OfflineMark />
        <UserProfile />
      </Flex>
    </Flex>
  </Flex>
);

export default Header;
